export default "__VITE_ASSET__DYTRDury__"